var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-view',{on:{"click":function($event){return _vm.$emit('input')}}},[_c('img',{staticClass:"arrow-img",class:{ 'arrow-img-collapsed': !_vm.expanded },attrs:{"src":require('@/assets/icons/arrow-down-blue.svg'),"height":"11","width":"13","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }